module.exports = __webpack_public_path__ + "static/media/chevron-circle-down.c400ea1f.svg";